"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const PremiumCompanyProfile_1 = require("./PremiumCompanyProfile");
exports.default = PremiumCompanyProfile_1.PremiumCompanyProfile;
